var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{staticClass:"mt-2"},_vm._l((_vm.item.options),function(v){return _c('div',{key:v.id,staticClass:"col-12"},[(v.enabled)?_c('span',[_vm._v(_vm._s(v.title)),_c('i',{staticClass:"fa fa-check"})]):_c('span',[_vm._v(_vm._s(v.title)),_c('i',{staticClass:"fa fa-ban"})])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eacfe7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/action-items/types/MemberMessaging.vue
// module id = null
// module chunks = 